module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/error-404-ub.53baf921.svg";